import React, { useState } from "react";
import "../Styling-css/SliderForm.css";
import axios from "axios";

const SimpleSliderForm = () => {
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!image) {
      alert("Please select an image.");
      return;
    }

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("slider", image);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/sliders`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // Assuming the API returns the new slider data with a URL, title, and description
      setUploadedImages([...uploadedImages, response.data]);
      setImage(null);
      setTitle("");
      setDescription("");
    } catch (err) {
      setError(err.message || "Failed to upload image.");
      console.error("Error uploading image:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="slider-container">
      <h2 className="slider-heading">Upload Slider Image</h2>
      <form onSubmit={handleSubmit} className="slider-form">
        <input
          type="text"
          name="title"
          value={title}
          onChange={handleTitleChange}
          placeholder="Title"
          required
        />
        <textarea
          name="description"
          value={description}
          onChange={handleDescriptionChange}
          placeholder="Description"
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Uploading..." : "Upload Image"}
        </button>
        {error && <p className="error-message">Error: {error}</p>}
      </form>
    </div>
  );
};

export default SimpleSliderForm;
